export default "__VITE_ASSET__BZwjWzn0__"